import script from "./YoungPlayerEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./YoungPlayerEditorView.vue?vue&type=script&setup=true&lang=js"

import "./YoungPlayerEditorView.vue?vue&type=style&index=0&id=eb66fde2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb66fde2"]])

export default __exports__